import { Alert, Box } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import useListTitle from "hooks/useListTitle";
import { useQuery } from "react-query";
import { ResponseOfE2eRegressionTestResults } from "services/KnowfullyAdminClient";
import AppSection from "./AppSection";

const E2eRegressionTestsPage = () => {
  useListTitle("E2E Regression Test Results");

  const { e2eRegressionTestsService } = useGlobalContext();

  const { data, isLoading, isError } = useQuery<ResponseOfE2eRegressionTestResults>(
    "e2eRegressionTests",
    () => e2eRegressionTestsService.getResults()
  );

  const results = data?.data;

  return (
    <Box my={4}>
      {isError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Failed to load E2E regression test results.
        </Alert>
      )}
      <AppSection title="MyPortal" runs={results?.myPortal} isLoading={isLoading} />
      <AppSection title="KAdmin" runs={results?.kAdmin} isLoading={isLoading} sx={{ mt: 2 }} />
      <AppSection title="Faculty Portal" runs={results?.facultyPortal} isLoading={isLoading} sx={{ mt: 2 }} />
      <AppSection
        title="Organization Portal"
        runs={results?.organizationPortal}
        isLoading={isLoading}
        sx={{ mt: 2 }}
      />
    </Box>
  );
};

export default E2eRegressionTestsPage;
